export const SET_MINDSETS = "SET_MINDSETS";